import { TableBody, TableCell } from "@mui/material";
import { styled } from "@mui/material/styles";

type StyledTableBodyProps = {
  stripedTable?: boolean;
};

type StyledTableCellProps = {
  columnWidth?: string;
  isFirst: boolean;
  disabled?: boolean;
};

type ButtonTableCellProps = {
  disabled?: boolean;
};

export const StyledTableBody = styled(TableBody, {
  shouldForwardProp: (prop) => prop !== "stripedTable",
})<StyledTableBodyProps>(({ stripedTable }) => ({
  "& > *:nth-of-type(even)": {
    backgroundColor: stripedTable ? "#FAFAFB" : "inherit",
  },
}));

export const StyledTableCell = styled(TableCell, {
  shouldForwardProp: (prop) =>
    prop !== "columnWidth" && prop !== "isFirst" && prop !== "disabled",
})<StyledTableCellProps>(({ columnWidth, isFirst, disabled }) => ({
  width: columnWidth || "unset",
  padding: "0.5rem",
  fontWeight: isFirst ? 600 : 500,
  backgroundColor: disabled ? "#fff" : "inherit",
  "& > p": {
    fontSize: isFirst ? "16px" : "14px",
    fontWeight: "inherit",
  },
}));

export const ButtonTableCell = styled(TableCell, {
  shouldForwardProp: (prop) => prop !== "disabled",
})<ButtonTableCellProps>(({ disabled }) => ({
  padding: 0,
  backgroundColor: disabled ? "#fff" : "inherit",
}));
